export default "__VITE_ASSET__Ba7dk$rn__"